import { isNotEmpty } from '@/lib/utils'

export default function separator(sep = '-', a, b) {
	if (isNotEmpty(a) && isNotEmpty(b)) {
		return [a, b].join(sep)
	}
	if (a) return a
	if (b) return b
}
